import React from "react";
import Frame1 from "../subcomponents/Frame1";

const Header = () => {
      return(
            <div className="header">
                  <b className="logo">Logo</b>
                  <Frame1 />
            </div>
      );
};

export default Header;